export const Services = {
  TENABLE: 'tenableInformation',
  NESSUS: 'nessusInformation',
  RAPID7: 'rapid7Information',
  CROWDSTRIKE: 'crowdstrikeInformation',
  AZUREDEFENDER: 'azuredefenderInformation',
  MICROSOFTDEFENDER: 'microsoftdefenderInformation',
  AWSSECURITYHUB: 'awssecurityhubInformation',
  QUALYSVMDR: 'qualysvmdrInformation',
  QUALYSETM: 'qualysetmInformation',
  SNYK: 'snykInformation',
  INTUNE: 'intuneInformation',
  SENTINEL: 'sentinelInformation',
  SENTINELONE: 'sentineloneInformation',
  SPLUNK: 'splunkInformation',
  OKTA: 'oktaInformation',
  ORCA: 'orcaInformation',
  PRISMACLOUD: 'prismacloudInformation',
  DUO: 'duoInformation',
  WIZ: 'wizInformation',
  GITHUBSECURITY: 'githubsecurityInformation',
  GITLAB: 'gitlabInformation',
  VERACODE: 'veracodeInformation',
  SONARQUBE: 'sonarqubeInformation',
  KNOWBE4: 'knowbe4Information',
  GCPSCC: 'gcpsccInformation',
  SERVICENOWCMDB: 'servicenowcmdbInformation',
  CYBERARK: 'cyberarkInformation',
};
export const ServiceName = {
  TENABLE: 'tenable',
  NESSUS: 'nessus',
  RAPID7: 'rapid7',
  CROWDSTRIKE: 'crowdstrike',
  AZUREDEFENDER: 'azuredefender',
  MICROSOFTDEFENDER: 'microsoftdefender',
  AWSSECURITYHUB: 'awssecurityhub',
  QUALYSVMDR: 'qualysvmdr',
  QUALYSETM: 'qualysetm',
  SNYK: 'snyk',
  INTUNE: 'intune',
  SENTINEL: 'sentinel',
  SENTINELONE: 'sentinelone',
  SPLUNK: 'splunk',
  OKTA: 'okta',
  ORCA: 'orca',
  PRISMACLOUD: 'prismacloud',
  DUO: 'duo',
  WIZ: 'wiz',
  GITHUBSECURITY: 'githubsecurity',
  GITLAB: 'gitlab',
  VERACODE: 'veracode',
  SONARQUBE: 'sonarqube',
  KNOWBE4: 'knowbe4',
  GCPSCC: 'gcpscc',
  SERVICENOWCMDB: 'servicenowcmdb',
  CYBERARK: 'cyberark',
};
export enum Common {
  MPL = 'MPL',
}

export const Defaults = {
  IntegrationEmail: 'integration@integrations.com',
  SmartUserEmail: 'smart.user@smart.com',
  GlobalControlEmail: 'globalcontrol@globalcontrol.com',
  AiAgentEmail: 'aiuser@ai.com',
};

export const Logo = {
  TENABLE: 'tenable_logo',
  NESSUS: 'tenable_nessus_logo',
};

export const AZURE_FRAMEWORK = {
  NIST_SP_800_53_R5: 'NIST SP 800 53 R5',
};

export const EXEMPTED_CYBER_ARK_FRAMEWORKS = ['CAIQ_V1', 'CAIQ_2025'];
export const SMART_USER = 'smart.user@smart.com';
